import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from 'react-bootstrap';

function CrearEgreso() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [usuario, setUsuario] = useState('');
    const [numeroEgreso, setNumeroEgreso] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [usuarios, setUsuarios] = useState([]);
    const [proveedorId, setProveedorId] = useState('');
    const [nombreProveedor, setNombreProveedor] = useState('');
    const [tipoProveedor, setTipoProveedor] = useState('NIT');
    const [documentoProveedor, setDocumentoProveedor] = useState('');
    const [productos, setProductos] = useState([]);
    const [conceptoSeleccionado, setConceptoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    const [conceptosPago, setConceptosPago] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [showModalProveedor, setShowModalProveedor] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const [loading, setLoading] = useState(false);
    const proveedoresPorPagina = 10;

    // Estados para modales de confirmación
    const [showModalExito, setShowModalExito] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [mensajeError, setMensajeError] = useState('');
    const [egresoGuardadoId, setEgresoGuardadoId] = useState(null);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Usar el mismo permiso que documento soporte
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'ver_listado_documentos_soporte');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('ver_listado_documentos_soporte')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar usuarios
        axios.get('/usuarios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setUsuarios(response.data);
            })
            .catch(error => console.log('err: ' + error));

        // Cargar proveedores
        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setProveedores(response.data);
            })
            .catch(error => console.log('err: ' + error));

        // Cargar conceptos de pago
        axios.get('/conceptos-pago?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setConceptosPago(response.data);
            })
            .catch(error => console.log('err: ' + error));

        // Obtener el próximo número de egreso
        axios.get('/egresos/proximo-numero?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setNumeroEgreso(response.data.numero);
                }
            })
            .catch(error => console.log('err: ' + error));
    }, []);

    const agregarConcepto = () => {
        const concepto = conceptosPago.find(c => c.id == conceptoSeleccionado);
        if (concepto) {
            const nuevoProducto = {
                id: Date.now(),
                conceptos_pago_id: concepto.id,
                codigo: concepto.codigo,
                descripcion: concepto.nombre,
                cantidad: 1,
                precio: parseFloat(concepto.precio),
                descuento: 0,
                ajuste: 0,
                iva: 0,
                total: parseFloat(concepto.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setConceptoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                const subtotal = productoActualizado.precio * productoActualizado.cantidad;
                const descuentoTotal = subtotal * (productoActualizado.descuento / 100);
                const baseConDescuento = subtotal - descuentoTotal;
                const ivaTotal = baseConDescuento * (productoActualizado.iva / 100);
                productoActualizado.total = baseConDescuento + ivaTotal + productoActualizado.ajuste;
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let pagar = 0;
        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            pagar += producto.total;
        });
        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getProveedoresFiltrados = () => {
        if (!busquedaProveedor) return proveedores;
        return proveedores.filter(proveedor => {
            const nombre = proveedor.nombre_proveedor || '';
            const documento = proveedor.numero_documento || '';
            const busqueda = busquedaProveedor.toLowerCase();
            return nombre.toLowerCase().includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getProveedoresPaginados = () => {
        const proveedoresFiltrados = getProveedoresFiltrados();
        const inicio = (paginaActual - 1) * proveedoresPorPagina;
        const fin = inicio + proveedoresPorPagina;
        return proveedoresFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getProveedoresFiltrados().length / proveedoresPorPagina);
    };

    const seleccionarProveedor = (proveedor) => {
        setProveedorId(proveedor.id);
        setNombreProveedor(proveedor.nombre_proveedor);
        setTipoProveedor(proveedor.tipo_documento || 'NIT');
        setDocumentoProveedor(proveedor.numero_documento || '');
        setShowModalProveedor(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!proveedorId) {
            setMensajeError('Por favor seleccione un proveedor');
            setShowModalError(true);
            return;
        }
        
        if (productos.length === 0) {
            setMensajeError('Debe agregar al menos un concepto de pago');
            setShowModalError(true);
            return;
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const egresoData = {
            uid: userdata.user_id,
            users_id: parseInt(usuario),
            proveedor_id: parseInt(proveedorId),
            fecha_creacion: fecha,
            forma_pago: metodoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                conceptos_pago_id: parseInt(producto.conceptos_pago_id),
                cantidad: parseInt(producto.cantidad),
                vrunitario: parseFloat(producto.precio),
                descuento: parseFloat(producto.descuento),
                ajuste: parseFloat(producto.ajuste),
                iva: parseFloat(producto.iva)
            }))
        };

        try {
            const response = await axios.post('/egresos', egresoData);
            if (response.status === 200 || response.status === 201) {
                setEgresoGuardadoId(response.data.egreso?.id || null);
                setShowModalExito(true);
                
                // Limpiar formulario
                setProductos([]);
                setProveedorId('');
                setNombreProveedor('');
                setDocumentoProveedor('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalPagar(0);
                
                // Obtener nuevo número
                axios.get('/egresos/proximo-numero?uid=' + userdata.user_id)
                    .then(response => {
                        if (response.status === 200) {
                            setNumeroEgreso(response.data.numero);
                        }
                    });
            }
        } catch (error) {
            console.error('Error completo:', error);
            setMensajeError(error.response?.data?.message || error.message || 'Error al guardar el egreso');
            setShowModalError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleVolverListado = () => {
        setShowModalExito(false);
        history.push('/listado-egresos');
    };

    const handleCrearOtro = () => {
        setShowModalExito(false);
        setEgresoGuardadoId(null);
    };

    const handleVerEgreso = () => {
        if (egresoGuardadoId) {
            setShowModalExito(false);
            history.push(`/vista-previa-egreso/${egresoGuardadoId}`);
        }
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item">Crear Egreso</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Crear Egreso</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Información del Egreso</b></h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    
                                    <h5><b>Información del Proveedor</b></h5>
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={nombreProveedor}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Tipo *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={tipoProveedor}
                                                    disabled
                                                    required
                                                >
                                                    <option value="NIT">NIT</option>
                                                    <option value="CC">CC</option>
                                                    <option value="CE">CE</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>N° Documento *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={documentoProveedor}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info form-control"
                                                    onClick={() => setShowModalProveedor(true)}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Datos del Egreso</b></h5>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fecha}
                                                    onChange={(e) => setFecha(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Usuario *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={usuario}
                                                    onChange={(e) => setUsuario(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {usuarios.map(u => (
                                                        <option key={u.id} value={u.id}>{u.name} {u.lastname}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Egreso</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={numeroEgreso}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Método de Pago *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={metodoPago}
                                                    onChange={(e) => setMetodoPago(e.target.value)}
                                                    required
                                                >
                                                    <option value="10">Efectivo</option>
                                                    <option value="42">Consignación bancaria</option>
                                                    <option value="48">Tarjeta Crédito</option>
                                                    <option value="49">Tarjeta Débito</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Conceptos de Pago</b></h5>

                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label>Selecciona el Concepto</label>
                                                <select 
                                                    className="form-control" 
                                                    value={conceptoSeleccionado}
                                                    onChange={(e) => setConceptoSeleccionado(e.target.value)}
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {conceptosPago.map(concepto => (
                                                        <option key={concepto.id} value={concepto.id}>
                                                            {concepto.codigo} - {concepto.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info form-control"
                                                    onClick={agregarConcepto}
                                                >
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                    <th>Cant.</th>
                                                    <th>Precio</th>
                                                    <th>Desc %</th>
                                                    <th>Ajuste</th>
                                                    <th>IVA %</th>
                                                    <th>Total</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productos.map(producto => (
                                                    <tr key={producto.id}>
                                                        <td>{producto.codigo}</td>
                                                        <td>{producto.descripcion}</td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.cantidad}
                                                                onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                min="1"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.precio}
                                                                onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.descuento}
                                                                onChange={(e) => actualizarProducto(producto.id, 'descuento', e.target.value)}
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.ajuste}
                                                                onChange={(e) => actualizarProducto(producto.id, 'ajuste', e.target.value)}
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={producto.iva}
                                                                onChange={(e) => actualizarProducto(producto.id, 'iva', e.target.value)}
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm" 
                                                                value={parseFloat(producto.total || 0).toFixed(2)}
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => eliminarProducto(producto.id)}
                                                            >
                                                                ×
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="7" className="text-right"><strong>Total Bruto:</strong></td>
                                                    <td colSpan="2">
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={parseFloat(totalBruto || 0).toFixed(2)}
                                                            readOnly
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="7" className="text-right"><strong>Total a Pagar:</strong></td>
                                                    <td colSpan="2">
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={parseFloat(totalPagar || 0).toFixed(2)}
                                                            readOnly
                                                        />
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <hr />

                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={observaciones}
                                            onChange={(e) => setObservaciones(e.target.value)}
                                            placeholder="Observaciones del egreso..."
                                        ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-info mr-2" disabled={loading}>
                                            <i className="fas fa-save"></i> Guardar Egreso
                                            {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                        </button>
                                        <Link to="/listado-egresos" className="btn btn-secondary">
                                            <i className="fas fa-arrow-left"></i> Cancelar
                                        </Link>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Seleccionar Proveedor */}
            {showModalProveedor && (
                <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Proveedor</h5>
                                <button type="button" className="close" onClick={() => setShowModalProveedor(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Buscar por nombre o documento..."
                                        value={busquedaProveedor}
                                        onChange={(e) => {
                                            setBusquedaProveedor(e.target.value);
                                            setPaginaActual(1);
                                        }}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Documento</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getProveedoresPaginados().map((proveedor, index) => (
                                                <tr key={index}>
                                                    <td>{proveedor.nombre_proveedor}</td>
                                                    <td>{proveedor.numero_documento}</td>
                                                    <td>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarProveedor(proveedor)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {getTotalPaginas() > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === 1}
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                        >
                                            Anterior
                                        </button>
                                        <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === getTotalPaginas()}
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalProveedor(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Éxito */}
            <Modal show={showModalExito} onHide={() => setShowModalExito(false)} centered>
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>
                        <i className="fas fa-check-circle mr-2"></i>
                        Egreso Guardado Exitosamente
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-4">
                        <i className="fas fa-check-circle text-success" style={{fontSize: '4rem'}}></i>
                    </div>
                    <h5 className="mb-3">El egreso se ha guardado correctamente</h5>
                    <p className="text-muted mb-0">
                        N° Egreso: <strong>{numeroEgreso}</strong>
                    </p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleVolverListado}>
                        <i className="fas fa-list mr-2"></i>
                        Volver al Listado
                    </Button>
                    {egresoGuardadoId && (
                        <Button variant="info" onClick={handleVerEgreso}>
                            <i className="fas fa-eye mr-2"></i>
                            Ver Egreso
                        </Button>
                    )}
                    <Button variant="success" onClick={handleCrearOtro}>
                        <i className="fas fa-plus mr-2"></i>
                        Crear Otro Egreso
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Error */}
            <Modal show={showModalError} onHide={() => setShowModalError(false)} centered>
                <Modal.Header closeButton className="bg-danger text-white">
                    <Modal.Title>
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-4">
                        <i className="fas fa-times-circle text-danger" style={{fontSize: '4rem'}}></i>
                    </div>
                    <h5 className="mb-3">No se pudo guardar el egreso</h5>
                    <p className="text-muted mb-0">{mensajeError}</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={() => setShowModalError(false)}>
                        <i className="fas fa-times mr-2"></i>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default CrearEgreso;